import React, { useState, useEffect, useContext } from "react";
import topic from "./syllabus.json";
import "./CompleteSyllabus.css";
import ViewVideo from "./ViewVideo";
import Papa from "papaparse";
import csvFile from "./updated_subtopic_percentage_masters.csv";
import csvFile2 from "./main_topic_percentage_masters.csv";
import ProgressContext from "./ProgressContext";


import { useLoading } from "./LoadingContext";
import { API_BASE_URL, LOGOUT_URL } from "./config";
import { useRef } from "react";


const CompleteSyllabus = () => {
  const { progress, setProgress } = useContext(ProgressContext);
  const [openGroup, setOpenGroup] = useState(null);
  const [openSubTopic, setOpenSubTopic] = useState(null);
  const [SubTopicKey, setSubTopicKey] = useState(null);
  const [percentages, setPercentages] = useState({});
  const [percentagesSub, setPercentagesSub] = useState({});
  const [DayDuration, setDayDuration] = useState({});
  const [CurrentDay, setCurrentDay] = useState(0);
  const [showModal, setShowModal] = useState(false);
  // eslint-disable-next-line
  const [ProgressResponse, setProgressResponse] = useState(null);
  const [topicTotalData, setTopicTotalData] = useState([]);
  const [completedTopics, setCompletedTopics] = useState([]);

  const { showLoading, hideLoading } = useLoading();
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));



  const topicRefs = useRef({});
  const subTopicRefs = useRef({});
  const videoRefs = useRef({});

  const logoutUrl = LOGOUT_URL;

  // useEffect(() => {
  //   const fetchFeeStatus = async () => {
  //     try {
  //       const studentUniqueId = localStorage.getItem("student_unique_id");

  //       if (studentUniqueId && CurrentDay !== 0) {
  //         console.log(CurrentDay);
  //         const response = await fetch(
  //           `${API_BASE_URL}/get-student-payments/${studentUniqueId}?day=${CurrentDay}`
  //         );
  //         const data = await response.json();

  //         console.log("reponse from pay get:", data);

  //         setFeeStatus(data.status);

  //         setFeeCredits(Number(data.credits_in_account));

  //         setFeeRemain(data.remaining_fee);
  //         setFeeOneTimeRemain(data.remaining_one_time_payment);
  //         setFeeSaveForOneTimeRemain(data.savings_if_paid_today);

  //         setPaymentMode(data.mode);
  //         console.log("&&&&", data.status);

  //         if (data.status === "Incomplete") {
  //           alert(
  //             "💳 Your payment is incomplete. Please complete the payment."
  //           );
  //           localStorage.removeItem("student_unique_id");
  //           localStorage.removeItem("token");
  //           setshowMakeIncompletePayment(true);
  //         }

  //         setPaymentDetails({
  //           studentId: studentUniqueId,
  //           askStudentFee: data.ask_student_fee,
  //           remainingOneTimePayment: data.remaining_one_time_payment,
  //           savingsIfPaidToday: data.savings_if_paid_today,
  //           remainingPartialFee: data.remaining_fee,
  //         });

  //         setFeeData({
  //           status: data.status,
  //           credits: Number(data.credits_in_account),
  //           remainingFee: data.remaining_fee,
  //           remainingOneTimePayment: data.remaining_one_time_payment,
  //           savingsIfPaidToday: data.savings_if_paid_today,
  //           mode: data.mode,
  //           currentDay: CurrentDay,
  //         });
  //       }
  //     } catch (err) {
  //       console.error("Failed to fetch fee status:", err);
  //     }
  //   };

  //   fetchFeeStatus();
  // }, [CurrentDay, setFeeData]);


  useEffect(() => {
    showLoading("⏳ Fetching syllabus data... Please wait.");

    const fetchCsvFiles = async () => {
      try {
        const [csvResponse1, csvResponse2] = await Promise.all([
          fetch(csvFile).then((res) => res.text()),
          fetch(csvFile2).then((res) => res.text()),
        ]);

        Papa.parse(csvResponse1, {
          header: true,
          complete: (results) => {
            const percentageMapping = {};
            const percentageSubMapping = {};
            results.data.forEach((row) => {
              percentageMapping[row.main_topic] = row.Percentage;
              percentageSubMapping[row.video_title] = row.subtopic_percentage;
            });
            setPercentages(percentageMapping);
            setPercentagesSub(percentageSubMapping);
          },
        });

        Papa.parse(csvResponse2, {
          header: true,
          complete: (results) => {
            const DayMapping = {};
            results.data.forEach((row) => {
              DayMapping[row.Topic] = [row.Start_Day, row.End_Day];
            });
            setDayDuration(DayMapping);
          },
        });
      } catch (error) {
        console.error("Error fetching CSV files:", error);
      }
    };

    const fetchUserDetails = async () => {
      try {
        const studentUniqueId = localStorage.getItem("student_unique_id");
        const token = localStorage.getItem("token");
        if (studentUniqueId && token) {
          const response = await fetch(
            `${API_BASE_URL}/student_JoinDate/${studentUniqueId}?token=${token}`
          );
          const data = await response.json();

          if (response.status === 200) {
            setCurrentDay(data["days_difference"]);
          } else if (response.status === 403) {
            alert(
              "You seem to be logged in on another device/browser. Logging out from here."
            );
            localStorage.removeItem("student_unique_id");
            localStorage.removeItem("token");
            window.location.href = logoutUrl;
            return;
          } else if (response.status === 401) {
            alert("Your session has expired. Please log in again.");
            localStorage.removeItem("student_unique_id");
            localStorage.removeItem("token");
            window.location.href = logoutUrl;
            return;
          } else {
            alert("Failed to fetch details:", response.statusText);
          }
        } else {
          console.error("Student Unique ID not found in local storage");
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };

    const fetchSyllabusCompletedStatus = async () => {
      try {
        const studentUniqueId = localStorage.getItem("student_unique_id");
        const token = localStorage.getItem("token");
        if (studentUniqueId && token) {
          const response = await fetch(
            `${API_BASE_URL}/init_syllabus_progress_info/`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                student_id: studentUniqueId,
                token: token,
              }),
            }
          );

          if (response.status === 200) {
            const responseData = await response.json();
            setProgress(responseData.total_addition);
            setProgressResponse(responseData.total_addition);
            setTopicTotalData(responseData.topic_total_df);
            setCompletedTopics(responseData.topic_total_video);
          } else if (response.status === 403) {
            // alert(
            //   "You seem to be logged in on another device/browser. Logging out from here."
            // );
            // localStorage.removeItem("student_unique_id");
            // localStorage.removeItem("token");
            // window.location.href = logoutUrl;
            return;
          } else if (response.status === 401) {
            // alert("Your session has expired. Please log in again.");
            // localStorage.removeItem("student_unique_id");
            // localStorage.removeItem("token");
            // window.location.href = logoutUrl;
            return;
          } else {
            alert("Error fetching progress data:", response.statusText);
          }
        } else {
          console.error("Student Unique ID not found in local storage");
        }
      } catch (error) {
        console.error("Error fetching progress data:", error);
      }
    };

    Promise.all([
      fetchCsvFiles(),
      fetchUserDetails(),
      fetchSyllabusCompletedStatus(),
    ]).finally(() => hideLoading());

    // eslint-disable-next-line
  }, []);

  const toggleSubTopic = (subTopicKeyInner) => {
    setOpenSubTopic((prevOpenGroup) =>
      prevOpenGroup === subTopicKeyInner ? null : subTopicKeyInner
    );

    setTimeout(() => {
      subTopicRefs.current[subTopicKeyInner]?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };

  const toggleGroup = (groupName, StartDuration, EndDuration) => {
    if (CurrentDay >= StartDuration) {
      setOpenGroup((prevOpenSubTopic) =>
        prevOpenSubTopic === groupName ? null : groupName
      );

      setTimeout(() => {
        topicRefs.current[groupName]?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    } else {
      setShowModal(true);
    }
  };

  const getSubtopicPercentage = (topic) => {
    const topicObject = topicTotalData.find(
      (item) => item.main_topic === topic
    );
    return topicObject ? topicObject.subtopic_percentage : null;
  };

  const update_progress = async (groupName, subTopicKeyInner, title) => {
    const studentUniqueId = localStorage.getItem("student_unique_id");
    const token = localStorage.getItem("token");

    if (studentUniqueId && token) {
      console.log(title);
      const data = {
        student_id: studentUniqueId,
        video_title: title,
        token: token,
        main_topic: groupName,
        sub_topic: subTopicKeyInner,
      };
      showLoading("📚 Updating your study record..");

      try {
        const response = await fetch(
          `${API_BASE_URL}/add_syllabus_progress_info/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          }
        );

        if (response.status === 200) {
          const responseData = await response.json();
          console.log("Response Dasta:", responseData);
          // eslint-disable-next-line
          const totalAddition = responseData.total_addition;
          // eslint-disable-next-line
          const topicTotalData = responseData.topic_total_df;

          setProgress(responseData.total_addition); // Update progress in context
          setProgressResponse(responseData.total_addition);
          setTopicTotalData(responseData.topic_total_df);

          // Add the completed topic to the state
          setCompletedTopics((prevCompletedTopics) => [
            ...prevCompletedTopics,
            title,
          ]);
          // setLoading((prevLoading) => ({ ...prevLoading, endpoint3: false }))
          // console.log(completedTopics)
        } else if (response.status === 403) {
          alert(
            "You seem to be logged in on another device/browser. Logging out from here."
          );
          localStorage.removeItem("student_unique_id");
          localStorage.removeItem("token");
          window.location.href = logoutUrl;
          return;
        } else if (response.status === 401) {
          alert("Your session has expired. Please log in again.");
          localStorage.removeItem("student_unique_id");
          localStorage.removeItem("token");
          window.location.href = logoutUrl;
          return;
        } else {
          alert("Error: Updating Status.Contact Support");
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        await sleep(700);
        hideLoading();
      }
    }
  };

  const UpDateSubKey = (videoKey) => {
    const fileName = `${videoKey}.mp4`;
    setSubTopicKey(fileName);

    setTimeout(() => {
      videoRefs.current[videoKey]?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };



  return (
    <div className="topic-div">

      {/* PREMIUM SYLLABUS CARD EXPERIENCE V4 */}
      <section className="syllabus-premium-intro">
        <div className="syllabus-premium-intro-copy">
          <p className="syllabus-premium-eyebrow">
            YOUR LEARNING WORKSPACE
          </p>
          <h1>
            Learn. Practice. <span>Build Your Future.</span>
          </h1>
          <p>
            Every technology you master brings you closer to building
            real-world software. Explore the roadmap below, open your
            lectures, experiment with code and complete your milestones.
          </p>
          <div className="syllabus-premium-chips">
            <span>01 / Learn</span>
            <span>02 / Practice</span>
            <span>03 / Build</span>
            <span>04 / Grow</span>
          </div>
        </div>

        <div className="syllabus-premium-progress">
          <div className="syllabus-premium-progress-top">
            <span>YOUR LEARNING PROGRESS</span>
            <strong>{Number(progress || 0).toFixed(2)}%</strong>
          </div>
          <div className="syllabus-premium-track">
            <div
              className="syllabus-premium-fill"
              style={{
                width: `${Math.max(
                  0,
                  Math.min(100, Number(progress || 0))
                )}%`
              }}
            />
          </div>
          <p>
            Progress is earned through consistent learning and practice.
          </p>
          <div className="syllabus-premium-code-art" aria-hidden="true">
            <span>{"<code />"}</span>
            <span>const growth = practice + persistence;</span>
            <span>buildYourFuture();</span>
          </div>
        </div>
      </section>


      {localStorage.getItem("student_unique_id") &&
        localStorage.getItem("first_name") && (
          <div className="student-info-message">
            Hey... <span>{localStorage.getItem("first_name")}</span>,&nbsp; your
            StudyAIPlacement ID is{" "}
            <span>{localStorage.getItem("student_unique_id")}</span>
          </div>
        )}


      {!showModal &&
        topic.Topic_Menu.map((topicGroup) => {
          return Object.entries(topicGroup).map(([groupNumber, groupData]) => {
            const [groupName, groupContent] = Object.entries(groupData)[0];
            const percentage = percentages[groupName] || "N/A";
            const StartDuration = DayDuration[groupName]
              ? DayDuration[groupName][0] || "N/A"
              : "N/A";
            const EndDuration = DayDuration[groupName]
              ? DayDuration[groupName][1] || "N/A"
              : "N/A";
            const subtopicPercentage = getSubtopicPercentage(groupName);
            const subtopicPercentageNum = Number(subtopicPercentage);
            const percentageNum = Number(percentage);
            // console.log(subtopicPercentageNum, percentageNum);
            const tolerance = 0.0001; // Define a small tolerance value
            const pend_comp_status =
              Math.abs(subtopicPercentageNum - percentageNum) <= tolerance
                ? "completed"
                : "Pending";

            // console.log(pend_comp_status);
            return (
              <div
                key={groupNumber}
                className="topic-group2"
                ref={(el) => (topicRefs.current[groupName] = el)}
              >
                <div className="main-topic2">
                  <h2>
                    <button
                      className="main-topic3"
                      onClick={() =>
                        toggleGroup(groupName, StartDuration, EndDuration)
                      }
                    >
                      <span className="syllabus-tech-index" aria-hidden="true">
                        {String(groupNumber).padStart(2, "0")}
                      </span>
                      <span className="main-topic-name">
                        {`${groupNumber}.${groupName}`}{" "}
                      </span>
                      <div className="syllabus-tech-progress">
                        <div
                          className="syllabus-tech-progress-fill"
                          style={{
                            width: `${
                              percentageNum > 0
                                ? Math.min(
                                    100,
                                    Math.max(
                                      0,
                                      (subtopicPercentageNum / percentageNum) * 100
                                    )
                                  )
                                : 0
                            }%`
                          }}
                        />
                      </div>
                      <span className="syllabus-tech-expand" aria-hidden="true">
                        {openGroup === groupName ? "−" : "+"}
                      </span>
                      <span className="ce-text">
                        {subtopicPercentage !== null ? (
                          <div className="complete-text">
                            {`${Number(subtopicPercentage).toFixed(
                              2
                            )} % completed`}
                          </div>
                        ) : (
                          <div className="empty-text">{`${Number(
                            subtopicPercentage
                          ).toFixed(2)} % completed`}</div>
                        )}
                      </span>

                      <span className="second-text">
                        <span style={{ color: "blue" }}>
                          {groupName === "SQL"
                            ? `${percentage}% Video`
                            : `${percentage - 1}% Video &`}{" "}
                        </span>{" "}
                        {/* Video Section */}
                        {groupName !== "SQL" && (
                          <span style={{ color: "red" }}>1% Assignment </span>
                        )}{" "}
                        {/* Assignment Section */}
                      </span>

                      <span className="StartDuration-text">
                        Day-{StartDuration} to Day-{EndDuration}
                      </span>
                      <div
                        className={`complete-status ${
                          pend_comp_status === "completed"
                            ? "completed"
                            : "pending"
                        }`}
                      >
                        <span className="complete-status-span">
                          {pend_comp_status}
                        </span>
                      </div>
                    </button>
                  </h2>
                </div>

                {openGroup === groupName && (
                  <ul className="ul-out">
                    {/* EXPANDED LECTURE EXPERIENCE V1 */}
                    <li className="premium-learning-guidance">
                      <span className="premium-guidance-icon" aria-hidden="true">
                        ✦
                      </span>
                      <div>
                        <strong>Learn it. Practice it. Master it.</strong>
                        <p>
                          Watch each lecture, reproduce the code, experiment,
                          explore errors independently and complete your milestones.
                        </p>
                      </div>
                      <span className="premium-guidance-steps">
                        WATCH → PRACTICE → EXPERIMENT → COMPLETE
                      </span>
                    </li>
                    {groupContent.map((subTopic, i) => {
                      // {console.log(subTopic)}
                      const subTopicVal = Object.values(subTopic)[0];
                      const subTopicKeyInner = Object.keys(subTopicVal)[0];
                      const subTopicvalInner = Object.values(subTopicVal)[0];

                      return (
                        <React.Fragment key={i}>
                          <button
                            className="sub-css"
                            onClick={() => toggleSubTopic(subTopicKeyInner)}
                            ref={(el) =>
                              (subTopicRefs.current[subTopicKeyInner] = el)
                            }
                          >
                            <span className="premium-topic-index">
                              {String(i + 1).padStart(2, "0")}
                            </span>
                            <span className="premium-topic-title">
                              {subTopicKeyInner}
                            </span>
                            <span className="premium-topic-count">
                              {Array.isArray(subTopicvalInner)
                                ? `${subTopicvalInner.length} Lectures`
                                : "Topic"}
                            </span>
                            <span className="premium-topic-chevron" aria-hidden="true">
                              {openSubTopic === subTopicKeyInner ? "−" : "+"}
                            </span>
                          </button>

                          {openSubTopic === subTopicKeyInner && (
                            <ul>
                              {Array.isArray(subTopicvalInner) ? (
                                <ul>
                                  {subTopicvalInner.map((item, index) => (
                                    <li className="li-dot-remove" key={index}>
                                      <div className="sub-topic-list">
                                        <div className="in-topic-name">{`${
                                          index + 1
                                        } - ${item}`}</div>
                                        <div className="in-btn-name">
                                          <button
                                            className="btn-upload"
                                            onClick={() =>
                                              UpDateSubKey(
                                                `${groupName}-${subTopicKeyInner}-${item}`
                                              )
                                            }
                                            ref={(el) =>
                                              (videoRefs.current[
                                                `${groupName}-${subTopicKeyInner}-${item}`
                                              ] = el)
                                            }
                                          >
                                            View Video
                                          </button>
                                        </div>
                                        <div className="in-per-name">
                                          {percentagesSub[item] !==
                                          undefined ? (
                                            <>
                                              <div className="second-text2">
                                                {`${Number(
                                                  percentagesSub[item]
                                                ).toFixed(4)} %`}
                                              </div>
                                            </>
                                          ) : (
                                            "N/A"
                                          )}
                                        </div>
                                        <div className="Mark-Complete">
                                          <button
                                            onClick={() =>
                                              update_progress(
                                                groupName,
                                                subTopicKeyInner,
                                                item
                                              )
                                            }
                                            className={`button-common ${
                                              completedTopics.includes(item)
                                                ? "complete-btn"
                                                : "mark-btn"
                                            }`}
                                            disabled={completedTopics.includes(
                                              item
                                            )}
                                          >
                                            {completedTopics.includes(item)
                                              ? "Completed"
                                              : "Mark Complete"}
                                          </button>
                                        </div>
                                      </div>
                                      {`${groupName}-${subTopicKeyInner}-${item}.mp4` ===
                                        SubTopicKey && (
                                        <div>
                                          <button
                                            className="close-video-btn"
                                            onClick={() => setSubTopicKey(null)}
                                          >
                                            Close Video
                                          </button>
                                          <div className="premium-now-learning">
                                            <span>NOW LEARNING</span>
                                            <strong>{item}</strong>
                                          </div>
                                          <ViewVideo
                                            props={`${groupName}-${subTopicKeyInner}-${item}.mp4`}
                                          />
                                        </div>
                                      )}
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                subTopicvalInner
                              )}
                            </ul>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </ul>
                )}
              </div>
            );
          });
        })}

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <p className="model-text">
              <strong>Hey buddy,</strong> <br />
              <br />
              <div className="modal-font">
                It's not the right time to start new material. Focus on
                finishing the current syllabus first. If that's done,
                concentrate on revising, practicing, and doing more exercises to
                master the content. Only then should you move on, and make sure
                it's within a reasonable timeframe.
              </div>
            </p>
            <button className="modal-btn" onClick={() => setShowModal(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompleteSyllabus;
